// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608101648/js/" + chunkId + "." + {"44":"c3aa4ecf","225":"af2529d5","481":"5d65e66d","486":"bd1b04b9","770":"618b7cee"}[chunkId] + ".0.9163357112124525.chunk.js";
};